import React from 'react'
import moment from 'moment'
import {
  CardContainer,
  CardHeader,
  CardBody,
  Row,
  CardService,
  IconCircle,
  DataLabel,
  CardAdditionalService
} from './styles'

import blockIcon from '../../assets/icons/block-duotone.svg'
import { FiAlertTriangle } from 'react-icons/fi'
import serviceIcon from '../../assets/icons/comb-scissors-duo.svg'
import { SOLICITATION_CATEGORY, getRecurrenceOptions, getProfessionalCategory } from '../../utils/constants'

const SolicitationCard = ({ solicitationData }) => {
  const types = {
    [SOLICITATION_CATEGORY.AGENDA_BLOCK]: {
      title: 'Bloqueio de agenda',
      headerColor: '#777777'
    },
    [SOLICITATION_CATEGORY.SCHEDULING]: {
      title: 'Novo agendamento',
      headerColor: '#009CA6',
      serviceColor: '#B3EDF0',
      additionalServiceColor: '#E8FEFF'
    },
    [SOLICITATION_CATEGORY.OVERBOOK]: {
      title: 'Novo encaixe',
      headerColor: '#009CA6',
      serviceColor: '#B3EDF0',
      additionalServiceColor: '#E8FEFF'
    },
    [SOLICITATION_CATEGORY.SCHEDULING_UPDATE]: {
      title: 'Alteração de agendamento',
      headerColor: '#FF8200',
      serviceColor: '#FFDAB3',
      additionalServiceColor: '#FFF3E6'
    },
    [SOLICITATION_CATEGORY.OVERBOOK_UPDATE]: {
      title: 'Alteração de encaixe',
      headerColor: '#FF8200',
      serviceColor: '#FFDAB3',
      additionalServiceColor: '#FFF3E6'
    },
    [SOLICITATION_CATEGORY.AGENDA_BLOCK_UPDATE]: {
      title: 'Alteração de bloqueio',
      headerColor: '#777777'
    }
  }

  const solicitationType = types[solicitationData.kind]
  const solicitationObj = solicitationData.solicitation

  const additionalServicesList = solicitationObj.additionalServices?.map((additionalService) => additionalService.name)

  const getRecurrenceLabel = ({ start, recurrence }) => {
    const recurrenceOptions = getRecurrenceOptions(start)
    return recurrenceOptions.find(option => option.value === recurrence).label
  }

  const isAgendaBlock = [SOLICITATION_CATEGORY.AGENDA_BLOCK, SOLICITATION_CATEGORY.AGENDA_BLOCK_UPDATE].includes(solicitationData.kind)

  const isFranchising = getProfessionalCategory() === 'FRANCHISING'

  return (
    <CardContainer>
      <CardHeader backgroudColor={solicitationData?.declined ? '#C80E3B' : solicitationType.headerColor}>
        {
          solicitationData?.declined
            ? (
              <>
                <FiAlertTriangle color='#EDEDED' size='24' />
              </>
            ) : (
              <>
                {isAgendaBlock ? (
                  <img src={blockIcon} alt="bloqueio" width={24} height={24}/>
                ) : (
                  <IconCircle>
                    <img src={serviceIcon} alt={solicitationType.title} />
                  </IconCircle>
                )}
              </>
            )
        }
        <span>{solicitationType.title} {solicitationData.referenceId && (`- ${solicitationData.referenceId}`)}</span>
      </CardHeader>
      {(solicitationObj && solicitationObj.service &&
        <CardService serviceColor={solicitationData?.declined ? '#ffb3bd' : solicitationType.serviceColor}>
          <span>{solicitationObj.service.name}</span>
        </CardService>
      )}
      {(solicitationObj && !!solicitationObj.additionalServices?.length &&
        <CardAdditionalService serviceColor={solicitationData?.declined ? '#FCE2E7' : solicitationType.additionalServiceColor}>
          <span>+ {additionalServicesList.join(', ')}</span>
        </CardAdditionalService>
      )}
      <CardBody>
        {solicitationObj && !!Object.keys(solicitationObj).length && (
          <>
            {isAgendaBlock ? (
              <>
                <Row>
                  <p><span>De:</span> {moment(solicitationObj.start).format('DD/MM/YYYY - HH:mm')}</p>
                  <p><span>Até:</span> {moment(solicitationObj.end).format('DD/MM/YYYY - HH:mm')}</p>
                </Row>
                {solicitationObj.recurrence && (
                  <Row>
                    <p><span>Recorrência:</span> {getRecurrenceLabel(solicitationObj)}</p>
                  </Row>
                )}
                {isFranchising && (
                  <Row>
                    <p><span>Substituto: </span>{solicitationObj?.professionalSubstituteId?.name ? solicitationObj.professionalSubstituteId.name : 'Nenhum'}</p>
                  </Row>
                )}

              </>
            ) : (
              <>
                <Row>
                  <p><span>Pet:</span> {solicitationObj.pet.name}</p>
                  <p><span>Cliente:</span> {solicitationObj.userName}</p>
                </Row>
                <Row>
                  <p><span>Dia:</span> {moment(solicitationObj.date).format('DD/MM')}</p>
                  <p><span>Horário:</span> {moment(solicitationObj.date).format('HH:mm')}</p>
                </Row>
              </>
            )}
          </>
        )}
        {!solicitationData.answerRead ? (
          <>
            {solicitationData.answerMessage ? (
              <Row bordered>
                <p><span>Resposta:</span> {solicitationData.answerMessage}</p>
              </Row>
            ) : solicitationData.questionMessage && (
              <Row bordered>
                <p><span>Solicitação:</span> {solicitationData.questionMessage}</p>
              </Row>
            )}
          </>
        ) : (
          <>
            {solicitationData.answerMessage && (
              <Row bordered flexWrap>
                <Row fullWidth flexStart>
                  {solicitationData.updatedAt && (
                    <DataLabel>{moment(solicitationData.updatedAt).format('DD/MM')}</DataLabel>
                  )}
                  <p><strong>Resposta:</strong> {solicitationData.answerMessage}</p>
                </Row>
                {solicitationData.questionMessage && (
                  <Row bordered fullWidth flexStart>
                    {solicitationData.createdAt && (
                      <DataLabel>{moment(solicitationData.createdAt).format('DD/MM')}</DataLabel>
                    )}
                    <p><strong>Solicitação:</strong> {solicitationData.questionMessage}</p>
                  </Row>
                )}
              </Row>
            )}
          </>
        )}
      </CardBody>
    </CardContainer>
  )
}

export default SolicitationCard
